import React from "react";
import InputField from "../../forms/input-field";

// Truncates in place at 2 decimal digits so the wrapper's subsequent
// field.onChange(e) picks up the already-shortened value.
const limitToTwoDecimals = (event) => {
  const raw = event.target.value;
  const decimalIndex = raw.indexOf(".");
  if (decimalIndex !== -1 && raw.length - decimalIndex - 1 > 2) {
    event.target.value = raw.slice(0, decimalIndex + 3);
  }
};

const StoreMinMaxTab = ({ disabled = false }) => {
  return (
    <div className="w-full 2xl:w-[40%] xl:w-[50%] lg:w-[60%] px-5 xl:px-10 mt-5">
      <InputField
        isDisabled={disabled}
        type="number"
        name="avg_days"
        placeholder="60"
        label="Days"
        labelWidth="10.5rem"
        extraAllowedChars="."
        handleChange={limitToTwoDecimals}
      />
      <InputField
        isDisabled={disabled}
        type="number"
        name="min_percentage"
        placeholder="0.00"
        label="Min Deviation"
        labelWidth="10.5rem"
        extraAllowedChars="."
        handleChange={limitToTwoDecimals}
        maxValue={100}
      />
      <InputField
        isDisabled={disabled}
        type="number"
        name="max_percentage"
        placeholder="0.00"
        label="Max Deviation"
        labelWidth="10.5rem"
        extraAllowedChars="."
        handleChange={limitToTwoDecimals}
        maxValue={100}
      />
    </div>
  );
};

export default StoreMinMaxTab;
